<template>
  <div class="w-full h-full">
    <div id="action-selection" class="absolute z-99" v-if="showSelect">
      <div class="text-color-white mt-15px ml-1/2  scheme-name">{{ schemeDetail.name }}方案</div>
      <div class="p-30px">
        <div class="remark text-18px">简介：{{ schemeDetail.remark }}</div>
        <div class="flex msg">
          <el-select
            popper-class="training_select-popper"
            v-model="operateType"
            @change="handleTypeChange"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in operationList"
              :value="item.value"
              :key="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
          <el-checkbox v-model="isShowMsg">提示信息</el-checkbox>
          <el-checkbox v-model="isAssessMode" :disabled="operateType === 0 || operateType === 1"
            >考核模式</el-checkbox
          >
        </div>
        <div class="w-full tc mt-40px flex justify-center">
          <el-button @click="executeScheme">执行方案</el-button>
        </div>
      </div>
    </div>
    <div class="absolute top-0 left-0 w-full h-full bg-[#00000000] z-9" ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowMsg: true,
      isAssessMode: false,
      operateType: 0,
      // 操作类型
      operationList: [
        {
          value: 0,
          label: '组装演示',
        },
        {
          value: 1,
          label: '拆卸演示',
        },
        {
          value: 2,
          label: '顺序组装',
        },
        {
          value: 3,
          label: '顺序拆卸',
        },
        {
          value: 4,
          label: '逻辑组装',
        },
        {
          value: 5,
          label: '逻辑拆卸',
        },
      ],
    }
  },
  props: {
    schemeDetail: {
      type: Object,
      default: null,
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  methods: {
    // 执行方案
    async executeScheme() {
      this.showDialog = false
      this.$emit('executeScheme', this.operateType, this.isShowMsg, this.isAssessMode)
      this.$emit('update:showSelect', false)
    },
    handleTypeChange(val) {
      if (val === 0 || val === 1) {
        this.isAssessMode = false
      }
    },
  },
}
</script>

<!-- <style lang="scss">
.el-popper.training_select-popper {
  border: none !important;
  background-color: #0a2247 !important;
  &[x-placement^='bottom'] .popper__arrow {
    border-bottom-color: #0a2247;
    &::after {
      border-bottom-color: #0a2247;
    }
  }
  .el-select-dropdown__item {
    font-size: 12px;
    color: #fff;
    &.hover,
    &:hover {
      background-color: rgba(24, 41, 72, 0.8) !important;
    }
  }
}
</style> -->
<style lang="scss" scoped>
@import '../css/select';
@import '../css/index';
#action-selection {
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 615px;
  height: 415px;
  background-image: url('../images/dialog2.png');
  .remark {
    color: #b7d9ee;
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    height: 110px;
  }
  .scheme-name {
    font-weight: bold;
    background-image: -webkit-repeating-linear-gradient(top, #fff, #ebeff3, #409bf1);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: 3px;
    font-size: 30px;
    transform: translate(-25%, 0px);
  }
  ::v-deep .el-select {
    width: 300px;
    .el-input__inner {
      height: 35px;
      background-color: rgba(24, 41, 72, 0.8) !important;
      border: none !important;
      color: rgb(158, 190, 224) !important;
    }
  }
  ::v-deep .el-button {
    font-size: 16px;
    background-color: #00c0ff;
  }
  ::v-deep .el-checkbox {
    .el-checkbox__label {
      font-size: 17px;
      color: #b7d9ee;
    }
    .el-checkbox__inner {
      width: 20px;
      height: 20px;
      background-color: #31547a;
      border: 1px solid white;
      &::after {
        border: 2px solid white;
        border-left: 0;
        border-top: 0;
        left: 5px;
        height: 10px;
        width: 6px;
      }
    }
    &.is-checked {
      .el-checkbox__inner {
        background-color: #00c0ff;
        border: 1px solid #00c0ff;
      }
    }
    &.is-disabled {
      .el-checkbox__label {
        color: #3b84b3;
      }
      .el-checkbox__inner {
        border: 1px solid #3b84b3;
      }
    }
  }
  .msg {
    justify-content: space-between;
    align-items: center;
  }
}
</style>
